module.exports = __webpack_public_path__ + "static/media/re.16aa0b5b.svg";